import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import RootErrorBoundary from "@/components/RootErrorBoundary";
import { bootstrapNative } from "@/native/bootstrap";
import { isNative } from "@/native/platform";

// Build 23 / v2.5.2 (2026-06-21) — P0 root-cause fix for the
// "cold-start blank screen" symptom on physical Android devices.
//
// Prior boot logic waited for `bootstrapNative()` to settle via
// `.finally(renderApp)`. Physical-device QA (Rick's Samsung S21)
// proved that on some cold-starts one of the Capacitor plugins
// (`Preferences.get` OR `CapacitorUpdater.notifyAppReady`) hangs
// indefinitely — the Promise never resolves NOR rejects. Because
// `.finally()` only fires on resolve/reject, React was never
// mounted, leaving the WebView stuck on the static
// `__wp_boot_loader` markup (8 UI nodes total).
//
// The fix is to mount React UNCONDITIONALLY. Native session
// hydration is a best-effort optimization; it must NEVER block
// the UI. Any component that needs the hydrated Preferences can
// await the exported `nativeBootstrapReady` Promise (which itself
// is timeout-wrapped and always resolves). See
// `native/bootstrap.js` for the timeout wrapper details.
const renderApp = () => {
  try {
    console.info("[WP_BOOT] renderApp start · native=%s", isNative());
  } catch (_e) { /* noop */ }
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <RootErrorBoundary>
        <App />
      </RootErrorBoundary>
    </React.StrictMode>,
  );
  try {
    console.info("[WP_BOOT] renderApp done");
  } catch (_e) { /* noop */ }
};

if (isNative()) {
  // Kick off native bootstrap in the background so its side-effects
  // (sessionStorage hydration from Preferences, sessionStorage
  // mirror wrapper install) can complete asynchronously — but do
  // NOT await it. React mounts immediately.
  try {
    console.info("[WP_BOOT] native detected, dispatching bootstrapNative in background");
  } catch (_e) { /* noop */ }
  bootstrapNative().catch((err) => {
    try {
      console.warn("[WP_BOOT] bootstrapNative rejected (non-fatal)", err);
    } catch (_e) { /* noop */ }
  });
}
renderApp();
